import CreateNewVendorApi from "./CreateNewVendorApi";

export default CreateNewVendorApi;